{
  "AUTHORIZED_INDIVIDUAL": "Persona autorizada",
  "BENEFICIAL_OWNER": "Beneficiario efectivo",
  "CHILD": "Menor",
  "FRIEND": "Amigo/a",
  "GRANDCHILD": "Nieto/a",
  "GRANDPARENT": "Abuelo/a",
  "GRANTOR": "Otorgante",
  "NIECE_NEPHEW": "Sobrino/Sobrina",
  "OTHER": "Otro",
  "PARENT": "Padre/Madre",
  "POWER_OF_ATTORNEY": "Poder notarial",
  "PROTECTOR": "Protector",
  "SETTLOR": "Fideicomitente",
  "SIBLING": "Hermano/a",
  "SPOUSE": "Esposo/a",
  "THIRD_PARTY": "Tercero",
  "TRUSTED_CONTACT": "Contacto de confianza",
  "TRUSTEE": "Fideicomisario",
  "DIRECTOR": "Director",
  "SENIOR_OFFICER": "Directivo principal"
}
